// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_8ht","cls2":"ImpactHubModal-cls2_-gq ImpactHubModal-cls1_8ht"};